var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgProfileShareIcon = function SvgProfileShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.288 10.559l-8.02-7.921a1.087 1.087 0 00-1.809.946V7.76c-7.32.09-13.125 1.767-13.125 9.696a11.118 11.118 0 003.797 8.028.837.837 0 001.284-.971c-2.066-7.553.98-9.558 8.05-9.674v4.579a1.087 1.087 0 001.808.946l8.021-7.917a1.371 1.371 0 00-.006-1.887z",
    stroke: "#fff",
    strokeOpacity: 0.8,
    strokeWidth: 1.4
  })));
};
export default SvgProfileShareIcon;